module.exports = __webpack_public_path__ + "static/img/benefit2.5edbb3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/bussiness/benefit2.png
// module id = SkI6
// module chunks = 30